module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PlusView.js"));
	}, "PlusView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PlusView!./src/pages/Learn/PLUS/PlusView.js
// module id = 1261
// module chunks = 431